import React, { Children } from 'react';
import classNames from 'classnames/bind';
import styles from './TechnicalMessageDotPanel.css';
var cx = classNames.bind(styles);
export var TechnicalMessageDotPanel = function TechnicalMessageDotPanel(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, Children.map(children, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('item')
    }, item);
  }));
};